// Login.js

import React from 'react'
import './Login.css';
import YunHeader from '../Common/YunHeader/YunHeader'
import YunSection from '../Common/YunSection/YunSection';

import { Input } from '@material-ui/core';

import { login } from '../../api/em';

import { setWindowTitle, cppSetWindowIcon, cppWriteBase64File, cppSetToMainWindow, cppCloseWindow, cppBroadcastWndMsg } from '../../api/cpp';
import { getImgBase64, openWindow, validatePhoneNum, debounce } from '../../utils/index';

import getProductInfo from '../../static/getProductInfo';

const defaultPng = require(`../../static/default/logo.png`).default;

class Login extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            userPhone: '',
            userPassword: '',
            ErrMsg: '',
            isShowContact: false,
            productInfo: {},
        };

        this.clickLogin = debounce(this.clickLogin.bind(this));
        this.userPhoneChanged = this.userPhoneChanged.bind(this);
        this.userPasswordChanged = this.userPasswordChanged.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.keyDownPassword = this.keyDownPassword.bind(this);
        this.showHelpBox = this.showHelpBox.bind(this);
    }

    // 校验密码（6-20 位）
    validatePassword(password) {
        return typeof password === 'string' && password.length >= 6 && password.length <= 20;
    }

    clickLogin() {
        if (!validatePhoneNum(this.state.userPhone)) {
            this.setState({
                ErrMsg: '请输入正确的手机号码',
            })
            return false;
        }
        if (!this.validatePassword(this.state.userPassword)) {
            this.setState({
                ErrMsg: '密码为 6-20 位',
            })
            return false;
        }
        this.setState({
            ErrMsg: '',
        });
        login({
            userPhone: this.state.userPhone,
            userPassword: this.state.userPassword,
        }).then(res => {
            if (res && res.err === 'ERR_OK') {
                this.props.history.push({
                    pathname: '/'
                });
            } else {
                this.setState({
                    ErrMsg: res.errMsg || '登录失败',
                })
            }
        }).catch((e) => {
            this.setState({
                ErrMsg: '网络错误',
            })
            this.showHelpBox()
        })
    }

    // 展示帮助弹框
    showHelpBox() {
        this.setState({
            isShowContact: true,
        })
    }

    // 打开帮助窗口
    clickOpenHelpWindow() {
        openWindow(window.location.origin + window.location.pathname + '#/help');
    }

    // 监听键盘事件 enter键位代替点击
    keyDownPassword(e) {
        if (e.keyCode === 13) {
            this.clickLogin()
        }
    }

    userPhoneChanged(e) {
        // 手机号码超过11位禁止输入
        if (e.target.value.length > 11) {
            return false;
        }
        this.setState({
            userPhone: e.target.value
        })
    }

    userPasswordChanged(e) {
        // 密码超过20位禁止输入
        if (e.target.value.length > 20) {
            return false;
        }
        this.setState({
            userPassword: e.target.value
        })
    }

    handleClose() {
        cppCloseWindow()
    }

    componentDidMount() {
        getProductInfo().then(productInfo => {
            this.setState({
                productInfo: productInfo
            })
            setWindowTitle(productInfo.title);
            getImgBase64(productInfo.ico, function(base64) {
                const writeFileState = cppWriteBase64File(productInfo.WindowIconFileName, base64);
                if (writeFileState) {
                    cppSetWindowIcon(productInfo.WindowIconFileName);
                }
            });
        })

        // 设置主窗口
        cppSetToMainWindow();

        // 通知其他页面回到登录页面了
        cppBroadcastWndMsg('Login_In')

        // 标记一下用户已经重新登录
        window.localStorage.setItem('sy_user_login_page', 'login')
    }

    render() {
        return (
            <div className="Login AppContainer">
                <YunHeader handleClose={this.handleClose} productInfo={this.state.productInfo} hideLogo hideTitle hideOnTop></YunHeader>
                <div className="LoginContainer">
                    <div className={this.state.isShowContact ? 'VersionInfo ShowHelp' : 'VersionInfo'}>
                        <img className="logo" src={this.state.productInfo.png} alt="" onError={(e) => {e.target.src = defaultPng}} />
                        <p className="AppTitle">{this.state.productInfo.title}</p>
                    </div>
                    <YunSection className={this.state.isShowContact ? 'LoginBox ShowHelp' : 'LoginBox'} width="193" height="232">
                        <div className="loginBoxWrapper show">
                            <Input className="phoneNumInput" onKeyDown={this.keyDownPassword} value={this.state.userPhone} onChange={this.userPhoneChanged} autoFocus placeholder="手机号" />
                            <div className="validCodeBox">
                                <Input type="password" onKeyDown={this.keyDownPassword} className="valicodeInput" value={this.state.userPassword} onChange={this.userPasswordChanged} placeholder="密码" />
                            </div>
                            <p className="ErrMsg">{this.state.ErrMsg}</p>
                            <div className="loginBtn YunBtn" onClick={this.clickLogin}>
                                登　录
                            </div>
                            <p className="LoginTip">首次登录将自动注册</p>
                        </div>
                    </YunSection>
                    <YunSection className={this.state.isShowContact ? 'contactBox ShowHelp' : 'contactBox'} width="193">
                        <div className="contact">
                            <p className="contactText">忘记密码请联系客服重置。如有其他问题，请点“联系我们”。</p>
                            <div className="contactBtn YunBtn" onClick={this.clickOpenHelpWindow}>
                                联系我们
                            </div>
                        </div>
                    </YunSection>
                </div>
            </div>
        )
    }
}

export default Login;
